var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offer-btn-mobile"},[(_vm.icon)?_c('CDynamicIcon',{staticClass:"icon mobile",class:{ stroked: _vm.stroked },attrs:{"icon":_vm.icon}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }